import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetClientLargeClaimUWPEPMByClientName = async (Id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_LARGE_CLAIM_UW_PEMP_BY_CLIENT_NAME + Id,
    token
  );
  return res;
};

export const UpdateLargeClaimUWPemp = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(Url.UPDATE_LARGE_CLAIM_UW_PEMP, payload, token);
  return res;
};

export const UpdateLargeClaimUWPempbyClient = async (clientId, UserId) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(Url.UPDATE_LARGE_CLAIM_UW_PEMP_CLIENT + `${clientId}?UserId=${UserId}`,"", token);
  return res;
};
